'use client'

import AllServicesHeroSection from '@/components/services/allServicesHeroSection'
import { BookOpenCheck } from 'lucide-react'
import AllServicesSubSection from '@/components/services/allServicesSubSection'
import TherapySessionJourney from '@/components/services/individual-therapy/therapySessionJourney'
import TherapueticApproach from '@/components/services/individual-therapy/therapeuticApproach'
import TherapyBenefits from '@/components/services/individual-therapy/therapyBenefits'
import ServiceBookingCTA from '@/components/services/ServiceBookingCTA'

const IndividualTherapyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <AllServicesHeroSection
        title="Supportive Individual Therapy: Your Space for Healing and Growth"
        description="One-on-one therapy sessions using evidence-based approaches to help you build coping skills, gain insight, and foster lasting emotional well-being"
      />

      {/* What is Individual Therapy Section */}
      <AllServicesSubSection
        title="What is Individual Therapy at ReACH Psychiatry?"
        para1="Individual therapy, also known as psychotherapy or counseling, is a collaborative process between you and a trained psychiatrist or therapist. At ReACH, it's a dedicated, confidential space where you can explore your thoughts, feelings, behaviors, and experiences."
        para2="Our goal is to help you understand yourself better, develop healthy coping mechanisms, navigate life's challenges, and work towards your personal goals for mental and emotional wellness. Through regular one-on-one sessions, you'll build a trusting relationship with your therapist who will guide and support you on your journey toward healing and growth."
        icon={BookOpenCheck}
      />

      {/* What to Expect Section */}
      <TherapySessionJourney />

      {/* Benefits Section */}
      <TherapyBenefits />

      {/* Our Therapeutic Approach Section */}
      <TherapueticApproach />

      {/* Next action */}
      <ServiceBookingCTA />
    </div>
  )
}

export default IndividualTherapyPage
